// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth, GithubAuthProvider, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArxHQlp3oB1pwf8--GcFiND9sLxP3OxyY",
  authDomain: "quickdb-cf865.firebaseapp.com",
  projectId: "quickdb-cf865",
  storageBucket: "quickdb-cf865.firebasestorage.app",
  messagingSenderId: "210083559003",
  appId: "1:210083559003:web:31fd79821d5af1109bf17e",
  measurementId: "G-0VBQX0S2FK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize providers
export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();
export const microsoftProvider = new OAuthProvider('microsoft.com');

// Configure providers
googleProvider.addScope('email');
googleProvider.addScope('profile');

githubProvider.addScope('user:email');
githubProvider.addScope('read:user');
githubProvider.addScope('user');

microsoftProvider.addScope('user.read');
microsoftProvider.addScope('email');
microsoftProvider.addScope('profile');

// Initialize Analytics (only in browser environment)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
